import React from "react";
import Widget from "../Widget";
import Swal from "../../shared/Swal";
import GroupSort from "./GroupSort";
import { openUnitFilterModal } from "./UnitFilter";
import _ from "lodash";
import { MODULE_ID } from "../../shared/moduleIds";
import config from "../../config";
import TeleReviewNavLink from "../TeleReview/features/TeleReviewMPV/components/Link";

export default class AbstractPatients extends Widget {
  constructor(props) {
    super(props);
  }

  SubNav({ GroupSort = true, disableMultiView } = {}) {
    return (
      <nav className="abstract-patients sub-nav">
        {this.surveil && (
          <a className="back-btn" href="/" onClick={this.backToPatientList}>
            &#9664;
          </a>
        )}

        {this.props.store.hasMultiPatient ? (
          <a
            href={`/patients${
              this.surveil
                ? ""
                : _.get(this.store.selectedListOption, "value.moduleId") ===
                    MODULE_ID.OBSTETRICS
                  ? "/ob-surveil"
                  : "/surveil"
            }/${_.get(this.props.match, "params.listIndex")}`}
            onClick={(e) => {
              e.preventDefault();
              !disableMultiView &&
                this.props.history.push(e.currentTarget.getAttribute("href"));
            }}
            className={this.cn({
              disabled: disableMultiView,
              active: this.surveil,
            })}
          >
            Multi-Patient View
          </a>
        ) : null}

        <TeleReviewNavLink parent={this} disabled={disableMultiView} />

        <div className="spacer-flex"></div>

        {this.store.simpleSearchEnabled && (
          <div className="simple-search-container">
            <div>
              <input
                className={this.cn({
                  "simple-search": true,
                  active: this.store.searchQuery,
                })}
                autoCorrect="off"
                type="search"
                placeholder="Search..."
                value={this.store.searchQuery}
                onChange={this.searchChange}
                ref={(r) => (this.refSimpleSearch = r)}
              />
              {this.store.searchQuery && (
                <button className="clear-button" onClick={this.searchClear}>
                  <span>&#10006;</span>
                </button>
              )}
            </div>
          </div>
        )}

        <div className="spacer-flex"></div>

        {this.togglePHI && (
          <a
            href="phi"
            className={this.cn({
              active: !this.store.showPHI,
            })}
            disabled={config.hidePHI}
            onClick={(e) => {
              e.preventDefault();
              if (config.hidePHI) return;
              this.togglePHI();
            }}
          >
            Hide PHI
          </a>
        )}

        {GroupSort ? (
          <a
            className={this.cn({
              disabled: this.store.groupSortDisabled,
              active:
                !this.store.groupSortDisabled && this.store.groupSortActive,
            })}
            href="group-sort"
            onClick={this.openGroupSort}
          >
            Group / Sort
          </a>
        ) : null}

        <a
          className={this.cn({
            disabled: !this.store.unitFilterEnabled,
            active: this.store.unitFilterActive,
          })}
          href="filter-unit"
          onClick={this.openUnitFilter}
        >
          Filter Units
        </a>
      </nav>
    );
  }

  searchChange = (e) => {
    this.store.searchQuery = e.target.value;
  };

  changeFontSize = (e) => {
    this.store.fontSize = e.target.value;
    this.setFontSize();
  };
  setFontSize = _.debounce(() => {
    this.props.store.setPref("pm.multiPatientFontSize", this.store.fontSize);
  }, 1000);

  openGroupSort = (e) => {
    e.preventDefault();

    this.store.modalLoading = false;

    if (this.store.groupSortDisabled) {
      return;
    }

    // store original start for reset.
    Swal.fire({
      customClass:
        this.store.moduleId.toString() === MODULE_ID.OBSTETRICS.toString()
          ? "ob-group-sort"
          : null,
      title: "Group / Sort",
      html: <GroupSort store={this.store} />,
      showConfirmButton: false,
    });
  };

  searchClear = () => {
    this.store.searchQuery = undefined;
    this.refSimpleSearch.value = "";
  };

  openUnitFilter = (e) => {
    e.preventDefault();
    openUnitFilterModal({ patientStore: this.store });
  };

  backToPatientList = (e) => {
    if (e) e.preventDefault();
    this.props.history.push(`/patients/${this.store.listIndex}`);
  };
}
